import React from "react";
import SectionTabs from "../../../components/SectionTabs/SectionTabs";

const tabs = [
  { to: "/admin/articles", label: "Articles", end: true },
  { to: "/admin/articles/categories", label: "Categories" },
  { to: "/admin/articles/media", label: "Media Library" },
];

const ArticlesNav = () => <SectionTabs tabs={tabs} />;

export default ArticlesNav;
